import { BinIcon } from "../../../components/icon/Icon";
import { Button } from "react-bootstrap";
import React from "react";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext";
import {
    MobileAccountBoxTopUpButtonBonusLabelStyled,
    MobileAccountBoxTopUpButtonBonusPresentsContainerStyled,
    MobileAccountBoxTopUpButtonStyled,
} from "./styled/MobileAccountBoxTopUpButtonStyled";
import { useBonusContext } from "../../../modules/Bonus/bonusContext";
import classNames from "classnames";

function MobileAccountBoxTopUpButton(props) {
    const {getLangPath} = useLangContext();
    const {bonusAvailablePercent, isHasBonusAvailable} = useBonusContext();
    const {onClick} = props;

    return <Button
        variant={'info'}
        onClick={onClick}
        name={'deposit'}
        as={MobileAccountBoxTopUpButtonStyled}
        className={classNames({'bonus-available': isHasBonusAvailable})}
    >
        {
            isHasBonusAvailable && <>
                <MobileAccountBoxTopUpButtonBonusLabelStyled>
                    +{bonusAvailablePercent}%
                </MobileAccountBoxTopUpButtonBonusLabelStyled>
                <MobileAccountBoxTopUpButtonBonusPresentsContainerStyled/>
            </>
        }
        <BinIcon name={'IcPlusCircle'}/>
        <div>{getLangPath('lite_version.home.top_up')}</div>
    </Button>
}

export default MobileAccountBoxTopUpButton;
